<template>
  <v-app>
    <v-main>
      <Header />
      <div class="alturacel"></div>
      <router-view :key="$route.fullPath" />
      <FooterPage />
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/PageHeader.vue'
import FooterPage from './components/PageFooter.vue'


export default {
  name: 'App',
  components: {
    Header,
    FooterPage
  },
  data: () => ({

  }),
  methods: {

  },
  created() {

  },
}
</script>

<style>
@import "@/assets/css/bootstrap.min.css";
@import "@/assets/css/fontawesome-all.min.css";
@import "@/assets/css/style.css";
@import "@/assets/css/avance.css";

@media (max-width:767px) {
  .hidden-xs {
    display: none !important;
  }

  .alturacel {
    margin-top: 0;
  }

}

@media (min-width:768px) and (max-width:991px) {
  .hidden-sm {
    display: none !important;
  }

  .alturacel {
    margin-top: 0px;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .hidden-md {
    display: none !important;
  }

  .alturacel {
    margin-top: 0px;
  }
}

@media (min-width:1200px) {
  .hidden-lg {
    display: none !important;
  }

  .alturacel {
    margin-top: 0px;
  }
}
</style>
